<template>
  <div class="container">
    <div class="noOrders" v-if="list.length == 0">
      <div v-if="!firstLoading">暂时还没有数据哦...</div>
      <van-loading v-else type="spinner" />
    </div>
    <div v-if="list.length > 0" style="height: 100%; overflow: auto">
      <!-- <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        style="height: calc(100% - 0.2vw); overflow: auto"
      > -->
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="到底啦~"
          @load="onLoad"
        >
          <div class="list" v-for="item in list" :key="item.employeeId">
            <div class="every">
              <div>
                <p class="name-list">{{ item.name }}</p>
                <p class="tel">{{ item.phoneNumber }}</p>
              </div>
              <div class="flex">
                <p class="green" v-if="item.employeeStatus == 6">审核通过</p>
                <p class="bule" v-if="item.employeeStatus == 2">等待审核</p>
                <p class="bule" v-if="item.employeeStatus == 4">等待后台审核</p>
                <p class="green" v-if="item.employeeStatus == '3,5'">
                  未通过审核
                </p>
                <p class="gray" v-if="item.employeeStatus == 5">未通过审核</p>
                <p class="gray" v-if="item.employeeStatus == 3">未通过审核</p>
                <!-- <button
                  v-if="item.employeeStatus == 4"
                  class="yellow"
                  @click="onClick(item.employeeId)"
                >
                  店长审核
                </button> -->
                <div class="looking" @click="onLook(item.employeeId)">
                  <img src="../../../assets/images/look.png" alt />
                </div>
                <!-- <button class="look" @click="onLook(item.id)">查看</button> -->
              </div>
            </div>
          </div>
        </van-list>
      <!-- </van-pull-refresh> -->
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  Dialog,
  Grid,
  GridItem,
  Image,
  List,
  PullRefresh,
  Loading,
  Overlay
} from "vant";
import service from "../../api/userCenterPage/userCenterPage";
import { mapGetters } from "vuex";
import loading from "../../components/loading/loading";
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Dialog.name]: Dialog,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    loading
  },

  data() {
    return {
      page: 1,
      pageSize: 8,
      list: [],
      loading: false,
      finished: false,
      // refreshing: false,
      firstLoading: true,
      isLoading:true, //loading状态
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.page = 1;
    this.pageSize = 8;
    this.employeeStatusId = this.$route.query.id;
    this.init();
  },
  methods: {
    onLoad() {
        this.page++;
        // if (this.refreshing) {
        //   this.refreshing = false;
        // }
        this.getList().then((list) => {
          this.list = this.list.concat(list.employeesReponseDtos);
          this.loading = false;

          if (list.total <=  this.list.length) {
            this.finished = true;
          }
        });
    },
    // onRefresh() {
    //   this.page = 1;
    //   this.finished = false;
    //   this.loading = true;
    //   this.list = [];
    //   this.isLoading =true
    //   this.getList().then((list) => {
    //      setTimeout(() => {
    //       this.isLoading = false;
    //     }, 500);
    //     if (list.employeesReponseDtos.length !== 0) {
    //       this.list = list.employeesReponseDtos;
    //       if (list.total <=  this.list.length) {
    //         this.finished = true;
    //         this.loading = false;
    //       }
    //     } else {
    //       this.list = [];
    //       this.loading = false;
    //     }
    //     this.refreshing = true;
    //     this.onLoad();
    //   });
    // },
    getList() {
      return new Promise((resolve, reject) => {
        service
          .list(this.employeeStatusId, this.page, this.pageSize)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject();
          });
      });
    },
    init() {
      this.firstLoading = true;
      this.loading = false;
      this.finished = false;
      this.getList().then((list) => {
         setTimeout(() => {
          this.isLoading = false;
        }, 500);
        this.firstLoading = false;
        if (list.employeesReponseDtos.length !== 0) {
          this.loading = false;
          this.list = list.employeesReponseDtos;
          console.log(this.list.length,list.total,181)
          if (list.total <=  this.list.length) {
            this.finished = true;
          }
        } else {
          this.list = [];
          this.loading = false;
        }
      });
    },
    onClick(id) {
      this.$router.push({ name: "manager", query: { id: id } });
    },
    onLook(id) {
      this.$router.push({ name: "clerkMessage", query: { id: id } });
    }
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.container {
  height: 100%;
  // height: calc(100% - 46px);
  .noOrders {
    width: 100%;
    text-align: center;
    font-size: 15px;
    color: #92909a;
    padding-top: 30vw;
  }
  .list {
    padding: 0 4vw;
    background: #fff;
  }
  .every {
    display: flex;
    justify-content: space-between;
    margin: 0 0.15rem;
    padding: 2.93333vw 0;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;
    height: 62px;
  }
  .look {
    background: linear-gradient(-45deg, #ee0a24, #f96f7f);
    color: #fff;
    height: 31px;
    border-radius: 5px;
    border: 0;
    width: 57px;
    height: 31px;
  }
  .looking {
    width: 16px;
    height: 16px;
  }
  .green {
    color: #1daa13;
    margin: 0 20px 0 0;
  }
  .gray {
    color: #a6a6a6;
    margin-right: 20px;
  }
  .bule {
    color: #0581ff;
    margin-right: 20px;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .yellow {
    background: linear-gradient(-45deg, #ff7e00, #ffb64e);
    border: 0;
    margin-right: 15px;
    color: #fff;
    height: 31px;
    border-radius: 5px;
    width: 78px;
  }
}
</style>